module.exports = __webpack_public_path__ + "img/nanjing_s.f1d21c7.png";